import { uniqby } from '@quromedical/utils';
import type { Organization } from 'fhir/r4';

import type { WithId } from '../types';
import { createReferenceFromResource, isValidReference } from './id';
import type { CreateReference } from './reference';

export const createOrganizationRef = (
  organization: WithId<Organization>,
): CreateReference =>
  createReferenceFromResource(organization, organization.name);

export const getOrganizationReferences = (
  userGroups: WithId<fhir4.Group>[],
): CreateReference[] => {
  const orgRefs = userGroups
    .map((group) => group.managingEntity)
    .filter(isValidReference);
  const uniqOrgs = uniqby(orgRefs, (org) => org.reference);

  return uniqOrgs;
};
